import { render, staticRenderFns } from "./AwardConfig.vue?vue&type=template&id=3c42546c&scoped=true"
import script from "./AwardConfig.vue?vue&type=script&lang=js"
export * from "./AwardConfig.vue?vue&type=script&lang=js"
import style0 from "./AwardConfig.vue?vue&type=style&index=0&id=3c42546c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c42546c",
  null
  
)

export default component.exports